module.exports = __webpack_public_path__ + "assets/2d99882ee27969d58d987aa3c87bf713.png";